import { useState } from "react";
import StackColor from "../../items/StackColor";
import { Logos } from "../../assets/stacks";

const uiText = {
  pt: {
    titulo: "TECNOLOGIAS",
    front: "FRONT-END",
    back: "BACK-END",
    banco: "BANCO DE DADOS",
    ferramentas: "FERRAMENTAS",
    frameworks: "FRAMEWORKS",
    infraestrutura: "INFRAESTRUTURA"
  },
  en: {
    titulo: "TECHNOLOGIES",
    front: "FRONT-END",
    back: "BACK-END",
    banco: "DATABASE",
    ferramentas: "TOOLS",
    frameworks: "FRAMEWORKS",
    infraestrutura: "INFRASTRUCTURE"
  }
};

function Stacks({ language }) {
    const ui = uiText[language];
    
    const [filters, setFilters] = useState({
        front: true,
        back: true,
        banco: false,
        ferramentas: false,
        frameworks: false,
        infraestrutura: false
    });

    const toggleFilter = (key) => {
        setFilters(prev => ({ ...prev, [key]: !prev[key] }));
    };

    return (
        <section id="tech">
            <div className='box-title-section'>
            <p className='back-legend'>{ui.titulo}</p>
            <h2 className='front-legend2'>{ui.titulo}</h2>
            </div>

            <div className="stack-filters">
                <button className={`filter-btn ${filters.front ? 'active' : ''}`} onClick={() => toggleFilter('front')}>{ui.front}</button>
                <button className={`filter-btn ${filters.back ? 'active' : ''}`} onClick={() => toggleFilter('back')}>{ui.back}</button>
                <button className={`filter-btn ${filters.banco ? 'active' : ''}`} onClick={() => toggleFilter('banco')}>{ui.banco}</button>
                {/* <button className={`filter-btn ${filters.ferramentas ? 'active' : ''}`} onClick={() => toggleFilter('ferramentas')}>{ui.ferramentas}</button> */}
                <button className={`filter-btn ${filters.frameworks ? 'active' : ''}`} onClick={() => toggleFilter('frameworks')}>{ui.frameworks}</button>
                <button className={`filter-btn ${filters.infraestrutura ? 'active' : ''}`} onClick={() => toggleFilter('infraestrutura')}>{ui.infraestrutura}</button>
            </div>

            {/* Back-End */}
            <div className={filters.back ? "stack-section-wrapper" : "stack-section-wrapper hidden"}>
                <div className="stack-section left">
                    <div className="card-tech">
                    <h3>{ui.back}</h3>
                    <div className="stack-marquee">
                        <div className="stack-track">
                            <StackColor desc="python" icon={Logos.python} altText="Python" />
                            <StackColor desc="csharp" icon={Logos.csharp} altText="C#" />
                            <StackColor desc="node" icon={Logos.node} altText="Node" />
                            {/* <StackColor desc="java" icon={Logos.java} altText="Java" /> */}
                            {/* <StackColor desc="delphi" icon={Logos.delphi} altText="Delphi" /> */}
                            <StackColor desc="python" icon={Logos.python} altText="Python" />
                            <StackColor desc="csharp" icon={Logos.csharp} altText="C#" />
                            <StackColor desc="node" icon={Logos.node} altText="Node" />
                            {/* <StackColor desc="java" icon={Logos.java} altText="Java" /> */}
                            {/* <StackColor desc="delphi" icon={Logos.delphi} altText="Delphi" /> */}
                        </div>
                    </div>
                    </div>
                </div>
            </div>

            {/* Front-End */}
            <div className={filters.front ? "stack-section-wrapper" : "stack-section-wrapper hidden"}>
                <div className="stack-section right">
                    <div className="card-tech">
                    <div className="stack-marquee reverse">
                        <div className="stack-track">
                            <StackColor desc="react" icon={Logos.react} altText="React" />
                            <StackColor desc="javascript" icon={Logos.javascript} altText="Javascript" />
                            <StackColor desc="typescript" icon={Logos.typescript} altText="TypeScript" />
                            {/* <StackColor desc="html" icon={Logos.html} altText="Html" /> */}
                            {/* <StackColor desc="css" icon={Logos.css} altText="Css" /> */}
                            <StackColor desc="react" icon={Logos.react} altText="React" />
                            <StackColor desc="javascript" icon={Logos.javascript} altText="Javascript" />
                            <StackColor desc="typescript" icon={Logos.typescript} altText="TypeScript" />
                            {/* <StackColor desc="html" icon={Logos.html} altText="Html" /> */}
                            {/* <StackColor desc="css" icon={Logos.css} altText="Css" /> */}
                        </div>
                    </div>
                    <h3>{ui.front}</h3>
                    </div>
                </div>
            </div>
            
            {/* Banco de Dados */}
            <div className={filters.banco ? "stack-section-wrapper" : "stack-section-wrapper hidden"}>
                <div className="stack-section left">
                    <div className="card-tech">
                    <h3>{ui.banco}</h3>
                    <div className="stack-marquee ">
                        <div className="stack-track">
                            <StackColor desc="sqlserver" icon={Logos.sqlserver} altText="Sql Server" />
                            <StackColor desc="mysql" icon={Logos.mysql} altText="MySql" />
                            <StackColor desc="sqlite" icon={Logos.sqlite} altText="Sqlite" />
                            <StackColor desc="mongodb" icon={Logos.mongodb} altText="MongoDb" />
                            <StackColor desc="sqlserver" icon={Logos.sqlserver} altText="Sql Server" />
                            <StackColor desc="mysql" icon={Logos.mysql} altText="MySql" />
                            <StackColor desc="sqlite" icon={Logos.sqlite} altText="Sqlite" />
                            <StackColor desc="mongodb" icon={Logos.mongodb} altText="MongoDb" />
                        </div>
                    </div>
                    </div>
                </div>
            </div>

            
            {/* Ferramentas */}
            
            <div className={filters.ferramentas ? "stack-section-wrapper" : "stack-section-wrapper hidden"}>
                <div className="stack-section right">
                    <div className="card-tech">
                    
                    <div className="stack-marquee reverse">
                        <div className="stack-track">
                            {/* <StackColor desc="github" icon={Logos.github} altText="GitHub" /> */}
                            {/* <StackColor desc="figma" icon={Logos.figma} altText="Figma" /> */}
                            {/* <StackColor desc="notion" icon={Logos.notion} altText="Notion" /> */}
                            {/* <StackColor desc="visualstudio" icon={Logos.visualstudio} altText="VS Code" /> */}
                            {/* <StackColor desc="swagger" icon={Logos.swagger} altText="Swagger"/> */}
                            {/* <StackColor desc="github" icon={Logos.github} altText="GitHub" /> */}
                            {/* <StackColor desc="figma" icon={Logos.figma} altText="Figma" /> */}
                            {/* <StackColor desc="notion" icon={Logos.notion} altText="Notion" /> */}
                            {/* <StackColor desc="visualstudio" icon={Logos.visualstudio} altText="VS Code" /> */}
                            {/* <StackColor desc="swagger" icon={Logos.swagger} altText="Swagger"/> */}
                        </div>
                    </div>
                    <h3>{/* {ui.ferramentas} */} </h3>
                    </div>
                </div>
            </div>
            
            {/* Frameworks */}
            <div className={filters.frameworks ? "stack-section-wrapper" : "stack-section-wrapper hidden"}>
                <div className="stack-section left">
                    <div className="card-tech">
                    <h3>{ui.frameworks}</h3>
                    <div className="stack-marquee">
                        <div className="stack-track">
                            {/* <StackColor desc="tailwind" icon={Logos.tailwind} altText="Tailwind" /> */}
                            {/* <StackColor desc="springboot" icon={Logos.springboot} altText="Springboot" /> */}
                            <StackColor desc="dotnet" icon={Logos.dotnet} altText="Dotnet" />
                            <StackColor desc="flask" icon={Logos.flask} altText="Flask" />
                            {/* <StackColor desc="reactnative" icon={Logos.reactnative} altText="React Native"/> */}
                            <StackColor desc="nextjs" icon={Logos.nextjs} altText="Next.js"/>
                            <StackColor desc="fastapi" icon={Logos.fastapi} altText="Fast Api"/>
                            {/* <StackColor desc="tailwind" icon={Logos.tailwind} altText="Tailwind" /> */}
                            {/* <StackColor desc="springboot" icon={Logos.springboot} altText="Springboot" /> */}
                            <StackColor desc="dotnet" icon={Logos.dotnet} altText="Dotnet" />
                            <StackColor desc="flask" icon={Logos.flask} altText="Flask" />
                            {/* <StackColor desc="reactnative" icon={Logos.reactnative} altText="React Native"/> */}
                            <StackColor desc="nextjs" icon={Logos.nextjs} altText="Next.js"/>
                            <StackColor desc="fastapi" icon={Logos.fastapi} altText="Fast Api"/>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
            
            {/* Infraestrutura */}
            <div className={filters.infraestrutura ? "stack-section-wrapper" : "stack-section-wrapper hidden"}>
                <div className="stack-section right">
                    <div className="card-tech">
                    <div className="stack-marquee reverse">
                        <div className="stack-track">
                            <StackColor desc="windows" icon={Logos.windows} altText="Windows" />
                            <StackColor desc="android" icon={Logos.android} altText="Android"/>
                            <StackColor desc="azure" icon={Logos.azure} altText="Azure" />
                            {/* <StackColor desc="linux" icon={Logos.linux} altText="Linux" /> */}
                            <StackColor desc="git" icon={Logos.git} altText="Git" />
                            <StackColor desc="armbian" icon={Logos.armbian} altText="Armbian" />
                            <StackColor desc="vercel" icon={Logos.vercel} altText="Vercel" />
                            <StackColor desc="windows" icon={Logos.windows} altText="Windows" />
                            <StackColor desc="android" icon={Logos.android} altText="Android"/>
                            <StackColor desc="azure" icon={Logos.azure} altText="Azure" />
                            {/* <StackColor desc="linux" icon={Logos.linux} altText="Linux" /> */}
                            <StackColor desc="git" icon={Logos.git} altText="Git" />
                            <StackColor desc="armbian" icon={Logos.armbian} altText="Armbian" />
                            <StackColor desc="vercel" icon={Logos.vercel} altText="Vercel" />
                        </div>
                    </div>
                    <h3>{ui.infraestrutura}</h3>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Stacks;